var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 45 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#Instagram_svg__filter0_d_6094_13079)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 6.5,
    y: 5,
    fill: "#fff",
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Instagram_svg__a)",
    d: "M22.503 11.991c-3.758 0-4.856.004-5.07.022-.771.064-1.25.185-1.774.446-.402.2-.72.432-1.034.757q-.855.889-1.042 2.19c-.061.42-.079.506-.082 2.656-.002.717 0 1.66 0 2.926 0 3.755.004 4.853.022 5.066.062.75.18 1.223.429 1.74a3.8 3.8 0 0 0 2.457 2.008c.371.095.78.148 1.307.173.223.01 2.495.016 4.768.016s4.546-.003 4.763-.014c.61-.028.963-.076 1.354-.177a3.77 3.77 0 0 0 2.457-2.012c.245-.504.369-.994.425-1.706.012-.155.017-2.627.017-5.097s-.006-4.938-.018-5.093c-.056-.723-.18-1.209-.433-1.722a3.6 3.6 0 0 0-.77-1.056q-.891-.853-2.191-1.04c-.42-.061-.505-.08-2.656-.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#Instagram_svg__b)",
    d: "M22.503 11.991c-3.758 0-4.856.004-5.07.022-.771.064-1.25.185-1.774.446-.402.2-.72.432-1.034.757q-.855.889-1.042 2.19c-.061.42-.079.506-.082 2.656-.002.717 0 1.66 0 2.926 0 3.755.004 4.853.022 5.066.062.75.18 1.223.429 1.74a3.8 3.8 0 0 0 2.457 2.008c.371.095.78.148 1.307.173.223.01 2.495.016 4.768.016s4.546-.003 4.763-.014c.61-.028.963-.076 1.354-.177a3.77 3.77 0 0 0 2.457-2.012c.245-.504.369-.994.425-1.706.012-.155.017-2.627.017-5.097s-.006-4.938-.018-5.093c-.056-.723-.18-1.209-.433-1.722a3.6 3.6 0 0 0-.77-1.056q-.891-.853-2.191-1.04c-.42-.061-.505-.08-2.656-.083z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.499 14.345c-1.805 0-2.031.008-2.74.04-.707.033-1.19.145-1.613.31-.437.169-.808.396-1.177.766-.37.37-.597.74-.767 1.177-.165.423-.277.906-.309 1.613-.031.71-.04.936-.04 2.741s.008 2.031.04 2.74c.033.707.145 1.19.31 1.613.169.437.396.808.766 1.178.369.37.74.597 1.176.767.423.164.906.276 1.613.309.71.032.935.04 2.74.04s2.03-.008 2.74-.04c.707-.033 1.19-.145 1.613-.31a3.25 3.25 0 0 0 1.176-.766c.37-.37.597-.74.767-1.178.163-.422.276-.906.309-1.613.032-.709.04-.935.04-2.74s-.008-2.032-.04-2.74c-.033-.708-.146-1.191-.309-1.614a3.3 3.3 0 0 0-.767-1.177c-.37-.37-.739-.597-1.177-.767-.423-.164-.906-.276-1.614-.309s-.934-.04-2.74-.04zm-.596 1.198h.596c1.774 0 1.984.006 2.685.038.648.03 1 .138 1.234.23.31.12.53.264.763.496.233.233.377.455.497.765.091.234.2.585.23 1.233.031.701.038.912.038 2.685s-.007 1.985-.039 2.685c-.03.648-.138 1-.229 1.234-.12.31-.264.531-.497.764a2.05 2.05 0 0 1-.763.497c-.234.091-.586.2-1.234.229-.7.032-.911.039-2.685.039s-1.985-.007-2.685-.04c-.648-.029-1-.137-1.234-.228a2.06 2.06 0 0 1-.764-.497 2.1 2.1 0 0 1-.498-.764c-.09-.234-.199-.586-.228-1.234-.032-.7-.039-.911-.039-2.686s.007-1.985.039-2.685c.03-.648.137-1 .228-1.234.12-.31.265-.532.498-.765s.454-.376.764-.497c.234-.091.586-.2 1.234-.23.613-.027.85-.035 2.089-.037zm4.143 1.104a.797.797 0 1 0 0 1.595.797.797 0 0 0 0-1.596m-3.547.932a3.413 3.413 0 1 0 .001 6.826 3.413 3.413 0 0 0-.001-6.826m0 1.197a2.215 2.215 0 1 1 0 4.431 2.215 2.215 0 0 1 0-4.43"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "Instagram_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 -17.8393 16.592 0 18.281 31.378)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Instagram_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(78.681 -2.863 13.04)scale(7.97425 32.8702)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F",
    stopOpacity: 0
  })))));
};
export default SvgInstagram;